// @flow
import React, { Component, Fragment } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'trpc-react-native-ui';

import { Icon, FullButton } from '../../components/common';
import theme from '../../theme-config';
import FormatService from '../../lib/format';
import { InfoDetailText } from '../../components/common/InfoDetailText';
import { WalletForfeitureCountdown } from '../../components/common/WalletForfeitureCountdown';

export default class MyWallet extends Component<Props> {
  componentDidMount() {
    this.props.fetchWalletForfeitureData && this.props.fetchWalletForfeitureData();
  }

  styles = getStyles();

  render() {
    const styles = this.styles;
    const {
      addMoneyButtonText,
      balance = 0,
      canAddMoneyToWallet,
      currentBalanceText,
      dateToCallWalletForfeiture,
      goToAddMoneyPage,
      hasUnauthenticatedPayment,
      iconName,
      infoContentText,
      infoTitleText,
      infoDetail,
    } = this.props;

    return (
      <View style={styles.container}>
        {!!dateToCallWalletForfeiture && <WalletForfeitureCountdown timestamp={dateToCallWalletForfeiture} />}
        <View style={styles.description}>
          {!!iconName && <Icon name={iconName} size={80} color={theme.secondaryColor} />}
          {balance != null && (
            <Fragment>
              <Text style={[styles.text, styles.currentBalance]}>{currentBalanceText}</Text>
              <Text style={[styles.text, styles.price]}>{FormatService.formatCentsToCurrency(balance, true)}</Text>
            </Fragment>
          )}
        </View>
        {canAddMoneyToWallet && (
          <FullButton disabled={hasUnauthenticatedPayment} onPress={goToAddMoneyPage} text={addMoneyButtonText} />
        )}
        <View style={styles.infoContainer}>
          {!!infoTitleText && <Text style={styles.text}>{infoTitleText}</Text>}
          {!!infoContentText && (
            <View>
              <Text style={styles.text}>{infoContentText}</Text>
              {!!infoDetail && (
                <InfoDetailText linkText={infoDetail.linkText} linkUrl={infoDetail.linkUrl} text={infoDetail.text} />
              )}
            </View>
          )}
        </View>
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.backgroundColor,
      paddingHorizontal: 13,
    },
    description: {
      alignItems: 'center',
      marginVertical: 45,
    },
    text: {
      textAlign: 'center',
    },
    currentBalance: {
      marginTop: 40,
      fontSize: 20,
    },
    price: {
      fontSize: 50,
    },

    infoContainer: {
      marginTop: 30,
    },
    icon: {
      color: theme.primaryColor,
      fontSize: 5,
      marginRight: 10,
    },
  });

type Props = {
  addMoneyButtonText: string,
  balance: ?number,
  canAddMoneyToWallet: boolean,
  currentBalanceText: string,
  dateToCallWalletForfeiture?: string,
  fetchWalletForfeitureData?: Function,
  goToAddMoneyPage: Function,
  hasUnauthenticatedPayment: boolean,
  iconName?: string,
  infoContentText?: string,
  infoDetail?: { [string]: string },
  infoTitleText?: string,
};
